<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Une chienne de vie</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">Par TA Moore</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Le monde s’achève non pas dans une explosion, mais dans un déluge. Des tornades ravagent le cœur de Londres, une chaleur étouffante fait fondre le bitume à New York et des couches de permafrost de plus en plus épaisses paralysent la Russie. Au début, les hommes se mobilisent, organisent des co-voiturages et évacuent les populations, mais le temps ne fait qu’empirer.</p>
<p class="P_Normal">À Durham, Danny Fennick, un professeur affable, s’est calfeutré chez lui en attendant que la tempête passe. Élevé dans les Highlands d’Écosse, il a connu des hivers plus rigoureux. Et surtout, il possède un avantage : c’est un loup-garou. Ou, plus exactement, un chien-garou. Moins impressionnant, mais tout aussi pratique.</p>
<p class="P_Normal">Néanmoins, les loups-garous n’y voient pas qu’un simple hiver et franchissent le Mur du Nord pour marquer leur nouveau territoire. Parmi eux, son ex, Jack, fils du Numitor de la meute et prince héritier, et son frère, qui rêve de fratricide.</p>
<p class="P_Normal">Un hiver de loup n’est pas blanc. Il est rouge comme le sang.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?f9d83df6